import { TableCell, TableRow } from '@mui/material';
import { memo } from 'react';
import useSelloutDistributionRow from '../../../hooks/useSelloutDistributionRow';
import { SelloutDistributionRowComponentProps } from '../../../types/selloutDistributionRow.types';
import SelloutDistributionRowItem from '../../item/components/SelloutDistributionRowItem';

export interface SelloutDesktopDistributionRowProps extends SelloutDistributionRowComponentProps {}

const SelloutDesktopDistributionRow = ({
  disabled,
  selloutSkus,
  distribution,
}: SelloutDesktopDistributionRowProps) => {
  const { distributionMap, disabledMap } = useSelloutDistributionRow({ distribution });

  return (
    <TableRow>
      {selloutSkus.map((sku) => (
        <TableCell key={sku.skuId} style={{ height: '46px' }}>
          <SelloutDistributionRowItem
            skuId={sku.skuId}
            disabled={disabled}
            disabledMap={disabledMap}
            distributionMap={distributionMap}
          />
        </TableCell>
      ))}
    </TableRow>
  );
};

export default memo(SelloutDesktopDistributionRow);
